class TrieNode {
    constructor() {
        this.children = {};
        this.isEndOfWord = false;
    }
}

class Trie {
    constructor() {
        this.root = new TrieNode();
    }

    insert(word) {
        let node = this.root;
        for (let char of word) {
            if (!node.children[char]) {
                node.children[char] = new TrieNode();
            }
            node = node.children[char];
        }
        node.isEndOfWord = true;
    }

    search(text) {
        let allWords = [];
    
        const dfs = (index, node, currentWord, startIndex) => {
          if (node.isEndOfWord) {
            allWords.push({word: currentWord, startIndex});
          }
    
          if (index < text.length) {
            const char = text[index];
            if (node.children[char]) {
              dfs(index + 1, node.children[char], currentWord + char, startIndex);
            }
          }
        };
    
        for (let i = 0; i < text.length; i++) {
          if (this.root.children[text[i]]) { // Only start DFS if the starting char exists in the trie
            dfs(i, this.root, '', i);
          }
        }
    
        // Filter out overlapped shorter words starting from the same index
        let filteredWords = allWords.filter((wordObj, index, self) =>
          !self.some(other => 
            other.startIndex === wordObj.startIndex && other.word.length > wordObj.word.length
          )
        );
    
        // Sort by starting index and extract words
        return filteredWords
          .sort((a, b) => a.startIndex - b.startIndex)
          .map(obj => obj.word);
      }
}

function preprocessCorpus(corpus) {
    let trie = new Trie();
    corpus.forEach(word => trie.insert(word.toLowerCase()));
    return trie;
}

function findCorpusStringsInQuery(trie, query) {
    return trie.search(query.toLowerCase());
}

export { preprocessCorpus, findCorpusStringsInQuery };